import {
  createActions, asyncInitialState, asyncSelectors, dateComparator
} from '../../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  reset: () => null,
  asyncs: {
  }
}, 'IESuppliers');

const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    toolPanel: false,
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
    cacheBlockSize: 10,
    maxBlocksInCache: 5,
  },
  Columns: [
    {
      headerName: 'Supplier',
      field: 'Supplier',
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data?.SupplierID) {
          return {
            Supplier: row.data.SupplierID,
            FieldValue: row.data.Supplier
          };
        } else return null;
      },
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/supplier-enquiry'
      },
      minWidth: 100,
      fixed: true,
    },
    { headerName: 'Abbreviation', field: 'SupplierAbbreviation', minWidth: 100, suppressSorting: true, fixed: true },
    {
      headerName: 'Main supplier', field: 'MainSupplier', minWidth: 100, fixed: true, valueGetter: (row) => {

        return row && row.data && row.data?.MainSupplierDisplay;
      },
    },
    { headerName: 'Warehouse', field: 'Warehouse', minWidth: 100, suppressSorting: true },
    { headerName: 'Supplier product', field: 'SupplierProduct', minWidth: 150, suppressSorting: true },
    { headerName: 'Buying unit', field: 'BuyingUnit', minWidth: 100, suppressSorting: true },
    { headerName: 'Landed price', field: 'LandedPriceDisplay', minWidth: 100, suppressSorting: true },
    { headerName: 'Price per', field: 'PricePer', minWidth: 80, suppressSorting: true },
    { headerName: 'Conversion factor', field: 'ConversionFactorDisplay', minWidth: 150, suppressSorting: true },
    { headerName: 'Stocking Unit', field: 'StockingUnit', minWidth: 100, suppressSorting: true },
    { headerName: 'Stock unit price', field: 'StockingPriceDisplay', minWidth: 120, suppressSorting: true },
    { headerName: 'Start', field: 'StartDate', minWidth: 100 },
    { headerName: 'End', field: 'EndDate', minWidth: 100 },
    { headerName: 'Supplier name', field: 'SupplierName', minWidth: 200 },
    { headerName: 'Warehouse name', field: 'WarehouseName', minWidth: 200, suppressSorting: true },
  ],
  Data: [],
  selectedFilters: {
    ShowInternalSuppliers: false,
  },
  filterRow: {
    formName: 'IESuppliersFilters',
    hidePreFilters: false,
    parameters: [
      {
        id: 0,
        type: 'TOGGLE_FIELD',
        props: {
          label: 'Show all internal suppliers',
          name: 'ShowInternalSuppliers',
          required: false,
          disabled: false,
          defaultValue: false
        }
      }
    ]
  },
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.reset:
      return initialState;
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }

    default:
      return state
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.inventoryEnquiry.reordering.suppliers,
  {
    data: data => data.Data,
    selected: data => data.selected,
  }
)

const syncSelector = {
  isLoading: state => state.inventoryEnquiry.reordering.suppliers.fetch_loading,
  gridOptions: state => state.inventoryEnquiry.reordering.suppliers.data.gridOptions,
  columns: state => state.inventoryEnquiry.reordering.suppliers.data.Columns,
  filterRow: state => state.inventoryEnquiry.reordering.suppliers.data.filterRow,
  selectedFilters: state => state.inventoryEnquiry.reordering.suppliers.data.selectedFilters,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)